export default __webpack_public_path__ + "a1db1930bd463a0a793cceba02c0a9f9.ttf";